import React, { FC, useRef, useState } from 'react';
import { FormLabel, FormControl } from '@chakra-ui/form-control';
import { Input, InputRightElement } from '@chakra-ui/input';

import { MdCalendarToday } from 'react-icons/md';

import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

import { DatepickerFilterProps } from './DatepickerFilter.props';
import { format, parse } from 'date-fns';
import './DatepickerFilter.style.css';
const DatepickerFilterView: FC<DatepickerFilterProps> = ({
  name,
  label,
  error,
  labelProps,
  helperText,
  isEditable,
  containerProps,
  searchDate,
  onDateChange,
  ...props
}) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const inputRef = useRef<HTMLInputElement>(null);

  const displayValue =
    selectedDate || searchDate
      ? selectedDate ||
        (selectedDate && format(selectedDate as Date, 'MM/dd/yyyy'))
      : '';

  return (
    <FormControl
      display="flex"
      alignItems="center"
      flexDirection="row"
      maxW="275px"
      flex="1"
      my={3}
      {...containerProps}>
      {label && (
        <FormLabel
          w="50%"
          mb="0"
          htmlFor={name}
          {...labelProps}
          textTransform="capitalize">
          {label}
        </FormLabel>
      )}
      <DatePicker
        wrapperClassName="formik-datepicker"
        toggleCalendarOnIconClick
        disabled={props.disabled || false}
        showIcon
        maxDate={new Date()}
        selected={
          searchDate
            ? parse(searchDate as string, 'yyyy-MM-dd', new Date())
            : selectedDate
        }
        icon={
          <InputRightElement mt={1}>
            <MdCalendarToday fill="#2FB64A" />
          </InputRightElement>
        }
        onChange={(date) => {
          setSelectedDate(date as Date);

          if (date && inputRef.current) {
            inputRef.current.value = `${format(date as Date, 'MM/dd/yyyy')}`;
          }

          if (onDateChange) {
            let dateResponse = date ? new Date(date) : null;
            let functionDateData = dateResponse
              ? `${dateResponse.getFullYear()}-${String(
                  dateResponse.getMonth() + 1,
                ).padStart(2, '0')}-${String(dateResponse.getDate()).padStart(
                  2,
                  '0',
                )}`
              : null;
            onDateChange(functionDateData);
          }
        }}
        customInput={
          <Input
            ref={inputRef}
            id="date-picker-input"
            value={(displayValue as string) || ''}
            isReadOnly={!isEditable}
            bg={props.readOnly ? '#DEDCDC' : 'inputColor'}
          />
        }
        {...props}
      />
    </FormControl>
  );
};

export default DatepickerFilterView;
